import React, { Fragment } from 'react'

export default () => {
    return (
        <Fragment>
            <h1>Oops something went wrong :(</h1>
            <div>
                We don’t recognize this email address.<br/>
                If you want to enjoy fortunica’s newsletter please download the app <a href="https://v8uh.adj.st/?adj_t=o9wefsp_sac9cn7">here</a>
            </div>
        </Fragment>
    )
}



// WEBPACK FOOTER //
// ./src/components/subscribe/error.js